import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { ReactComponent as OakLogo } from '../../assets/logos/oak.svg'
import ctaIcon from '../../assets/cta-04.svg'

const navLinks = [
  { label: 'Cortex', href: '/cortex' },
  { label: 'Toolkit', href: '/features' },
  { label: 'Request a Demo', href: '#demo' },
]

export default function Navigation() {
  const [mobileOpen, setMobileOpen] = useState(false)

  return (
    <nav className="fixed top-0 left-0 right-0 z-[10000] flex justify-center px-4 pt-4 md:px-6 md:pt-6">
      <div className="flex w-full max-w-nav items-center justify-between gap-6 transition-all duration-300">
        <div
          className="flex h-[72px] flex-1 items-center justify-between gap-8 rounded-[1.25rem] px-5 shadow-[1px_4px_20px_#0f0f0f1a] lg:justify-start lg:gap-12"
          style={{ backgroundColor: 'rgba(255,255,255,0.1)', backdropFilter: 'blur(24px)', WebkitBackdropFilter: 'blur(24px)' }}
        >
          <a href="/" aria-label="Oak" className="relative text-black">
            <OakLogo className="relative w-auto" style={{ height: '1.25rem', top: '-2px' }} />
          </a>
          <div className="hidden items-center gap-6 lg:flex">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-[18px] font-medium tracking-[-0.48px] text-black transition-opacity hover:opacity-60"
              >
                {link.label}
              </a>
            ))}
          </div>
          <button
            className="flex h-10 w-10 items-center justify-center lg:hidden"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <motion.svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              className="text-black"
              animate={{ rotate: mobileOpen ? 90 : 0 }}
              transition={{ duration: 0.2 }}
            >
              {mobileOpen ? (
                <>
                  <line x1="3" y1="3" x2="19" y2="19" />
                  <line x1="19" y1="3" x2="3" y2="19" />
                </>
              ) : (
                <>
                  <line x1="2" y1="7" x2="20" y2="7" />
                  <line x1="2" y1="15" x2="20" y2="15" />
                </>
              )}
            </motion.svg>
          </button>
        </div>

        <div
          className="hidden rounded-[1.25rem] shadow-[1px_4px_20px_#0f0f0f1a] lg:block"
          style={{ backgroundColor: 'rgba(255,255,255,0.1)', backdropFilter: 'blur(24px)', WebkitBackdropFilter: 'blur(24px)' }}
        >
          <a
            href="#start"
            className="flex items-center gap-2.5 rounded-pill px-5 py-5 text-[18px] font-medium tracking-[-0.48px] text-black transition-colors hover:bg-gray-50"
          >
            Start for Free
            <img src={ctaIcon} alt="" className="h-8 w-8" />
          </a>
        </div>

        <AnimatePresence>
          {mobileOpen && (
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.2 }}
              className="absolute top-full left-0 right-0 flex flex-col gap-1 p-4 shadow-lg lg:hidden"
              style={{ maxWidth: 'calc(100% - 2rem)', borderRadius: '1.5rem', paddingBottom: '1.65rem', margin: '1rem auto 0', backgroundColor: 'rgba(255,255,255,0.1)', backdropFilter: 'blur(24px)', WebkitBackdropFilter: 'blur(24px)' }}
            >
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  onClick={() => setMobileOpen(false)}
                  className="rounded-xl px-4 py-3 text-[18px] font-medium tracking-[-0.48px] text-black transition-colors hover:bg-gray-50"
                >
                  {link.label}
                </a>
              ))}
              <a
                href="#start"
                onClick={() => setMobileOpen(false)}
                className="mx-2 mt-2 flex items-center justify-center gap-2.5 rounded-pill bg-oak-black px-5 py-3 text-[18px] font-medium tracking-[-0.48px] text-white"
              >
                Start for Free
                <img src={ctaIcon} alt="" className="h-8 w-8" />
              </a>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </nav>
  )
}
